import { useRef, Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { getSkillGroupIconSvg } from '../../../utils/skills'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import { H3Alternate, H5, P2 } from '../../styled/typography/typography'
import { NameWithIcon, TooltipWrapper, tooltipOffset} from './_Styled'
import IconInfoSvg from '../../../static/images/Skills/icon_info.svg'
import colors from '../../../configuration/colors'
import useFrameworkSkillWithGroup from '../../../hooks/skills/useFrameworkSkillWithGroup'

// pure function for use in tooltips (or anywhere else) that can't access the store
export const FrameworkSkillPure = ({
  frameworkSkill,
  frameworkSkillGroup,
  Wrapper='div',
  iconSize='17px'
}) => (
  <NameWithIcon
    as={Wrapper}
    icon={getSkillGroupIconSvg(frameworkSkillGroup)}
    iconSize={iconSize}
  >
    {frameworkSkillGroup.name}: {frameworkSkill.name}
  </NameWithIcon>
)

const FrameworkSkill = ({
  frameworkSkillId,
  isEmphasized=true,
  isHeader,
  includeMeaningTip,
  role
}) => {
  const skill = useFrameworkSkillWithGroup(frameworkSkillId)
  const infoTip = useRef(null)

  return (
    <FlexAlignCenter
      onMouseOver={() => includeMeaningTip && ReactTooltip.show(infoTip.current)}
      onMouseOut={() => includeMeaningTip && ReactTooltip.hide(infoTip.current)}
      role={role}
    >
      <FrameworkSkillPure
        frameworkSkill={skill}
        frameworkSkillGroup={skill.group}
        Wrapper={isHeader ? H3Alternate : isEmphasized ? H5 : P2}
        iconSize={isHeader ? '22px' : '17px'}
      />
      {includeMeaningTip && (
        <>
          <img
            src={IconInfoSvg}
            alt="Info"
            ref={infoTip}
            data-tip={skill.meaning}
            data-for={`framework-skill-meaning-tip-${skill.id}`}
          />
          <TooltipWrapper>
            <ReactTooltip
              id={`framework-skill-meaning-tip-${skill.id}`}
              classNmae='framework-skill-meaning-tip'
              effect="solid"
              place="top"
              border
              borderColor={colors.ash}
              backgroundColor={colors.white}
              offset={{ left: tooltipOffset }}
            />
          </TooltipWrapper>
        </>
      )}
    </FlexAlignCenter>
  )
}

FrameworkSkill.propTypes = {
  frameworkSkillId: PropTypes.number.isRequired,
  isEmphasized: PropTypes.bool,
  isHeader: PropTypes.bool,
  includeMeaningTip: PropTypes.bool
}

export default FrameworkSkill
